import { render, staticRenderFns } from "./setMiddleName.vue?vue&type=template&id=96312d30&scoped=true"
import script from "./setMiddleName.vue?vue&type=script&lang=js"
export * from "./setMiddleName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96312d30",
  null
  
)

export default component.exports